"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._getHaulerContractorData = exports._deleteHaulerManagerData = exports._putHaulerManagerData = exports._postHaulerManagerData = exports._getHaulerManagerData = void 0;
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("utils/constants");
const error_response_1 = require("utils/error-response");
const getFromLocalStorage = {
    token: () => {
        const token = localStorage.getItem(constants_1.localStorageKey.token);
        if (token)
            return token;
        return '';
    }
};
const _getHaulerManagerData = ({ skip, take, filter, sort }) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/configuration/hauler';
    const filterString = filter ? JSON.stringify(filter) : undefined;
    const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
    const config = {
        params: { skip, take, filter: filterString, sort: sortString },
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: true,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: [],
            countData: 0
        };
    }
});
exports._getHaulerManagerData = _getHaulerManagerData;
const _postHaulerManagerData = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/configuration/hauler';
    try {
        const { data } = yield axios_1.default.post(url, arg, {
            headers: {
                'X-User-Token': getFromLocalStorage.token()
            }
        });
        return {
            isError: false,
            errorMessage: '',
            errorCode: 0,
            data: {
                id: data.data.id
            }
        };
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: true,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: {
                id: ''
            }
        };
    }
});
exports._postHaulerManagerData = _postHaulerManagerData;
const _putHaulerManagerData = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/configuration/hauler/${arg.id}`;
    try {
        const { data } = yield axios_1.default.put(url, arg, {
            headers: {
                'X-User-Token': getFromLocalStorage.token()
            }
        });
        return {
            isError: false,
            errorMessage: '',
            errorCode: 0,
            data: {
                id: data.data.id
            }
        };
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: true,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: {
                id: ''
            }
        };
    }
});
exports._putHaulerManagerData = _putHaulerManagerData;
const _deleteHaulerManagerData = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/configuration/hauler/${arg.id}`;
    try {
        const { data } = yield axios_1.default.delete(url, {
            headers: {
                'X-User-Token': getFromLocalStorage.token()
            }
        });
        return {
            isError: false,
            errorMessage: '',
            errorCode: 0,
            data: {
                id: data.data.id
            }
        };
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: true,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: {
                id: ''
            }
        };
    }
});
exports._deleteHaulerManagerData = _deleteHaulerManagerData;
const _getHaulerContractorData = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/master-data/hauler/contractor/${arg.id}`;
    const config = {
        headers: {
            'X-User-Token': getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: true,
            errorMessage: err.errorMessage,
            errorCode: err.errorCode || 500,
            data: [],
            countData: 0
        };
    }
});
exports._getHaulerContractorData = _getHaulerContractorData;
